import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const CONSENT_STORAGE_KEY = "sendfeedback_cookie_consent";

export const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [hasCookieConsent, setHasCookieConsent] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 640);
    };

    const checkConsent = () => {
      setHasCookieConsent(!!localStorage.getItem(CONSENT_STORAGE_KEY));
    };

    const handleScroll = () => {
      const threshold = window.innerWidth < 640 ? 200 : 400;
      setIsVisible(window.scrollY > threshold);
    };

    checkMobile();
    checkConsent();
    window.addEventListener("resize", checkMobile, { passive: true });
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("cookie-consent-updated", checkConsent);

    return () => {
      window.removeEventListener("resize", checkMobile);
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("cookie-consent-updated", checkConsent);
    };
  }, []);

  const prefersReducedMotion = typeof window !== "undefined"
    ? window.matchMedia("(prefers-reduced-motion: reduce)").matches
    : false;

  // Hide while cookie banner is showing on mobile to avoid overlap
  if (!isVisible || (isMobile && !hasCookieConsent)) return null;

  return (
    <div
      className={`fixed z-40 ${
        isMobile
          ? "bottom-3 left-3 right-3"
          : "bottom-6 right-6"
      } ${prefersReducedMotion ? "" : "animate-fade-in"}`}
      style={isMobile ? { paddingBottom: "env(safe-area-inset-bottom)" } : undefined}
    >
      <button
        onClick={() => navigate("/auth?mode=signup")}
        className={`group inline-flex items-center justify-center gap-2 rounded-full bg-foreground text-background px-5 sm:px-6 py-3.5 sm:py-4 min-h-[52px] text-sm font-medium tracking-[-0.005em] shadow-[0_12px_36px_-8px_rgba(21,34,27,0.35)] hover:bg-primary hover:shadow-[0_16px_40px_-8px_rgba(62,92,77,0.4)] transition-all duration-300 touch-manipulation ${
          isMobile ? "w-full" : ""
        }`}
      >
        Start 15-day free trial
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 flex-shrink-0" />
      </button>
    </div>
  );
};
